import { h } from "omi";

export function OmgGraphic() {
  return (
    <svg width="90" height="52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.1593 31.4951c4.3162-9.779 13.6232 2.7651 7.0813 9.7791-7.6209 8.1605-16.793-6.0023-9.9813-13.4209M22.5371 49.5022c.607-1.4163 2.0907-11.3977 2.5628-15.107.5395-4.114.8768-17.8721 2.6302-16.2535.5396.5395.607 1.6186.607 2.3605 0 1.5511.607 3.0348.7419 4.586 0 .2023 2.4953 20.2326 6.6767 19.0186 3.0349-.8767 4.6535-35.4744 6.5419-23.3349.3372 2.0233-.0675 4.114.1349 6.1372.2023 2.6977.8767 5.3279 1.6186 7.9582 1.1465 3.8442 2.1581 7.0814 4.6534 10.993M60.3719 12.7463c-.607.5396-5.8 3.7768-7.9581 9.2396-3.3047 8.4976-4.114 15.7814-.1349 17.5349 1.6186.7418 3.8442.7418 5.193.3372.8093-.2698 1.6186-.6745 2.3605-1.1465 2.9674-2.0233 8.7-9.9814 7.8232-11.7349-.4721-1.0117-2.2255-1.6861-3.3721.7418-1.2813 2.7651-.8767 6.407-1.079 9.3744-.1349 2.2931 1.0116 9.5094 1.2814 11.8024M88.4941 1.1463c.0674-.2023-3.6419 9.8465-4.5186 12.3419-3.1024 8.5651-5.4628 18.2093-3.9117 27.3814M79.3225 49.3674c.2697.0674 1.1465-.8768 1.8209-.6744 3.507.8767-5.8 2.5628-3.5745-.3372.4721-.607 1.4838-.607 2.2257-.607"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
